<script>
  import { createEventDispatcher, onMount } from "svelte";
  import { getPalette } from "../util/constants";
  import { windowIsMobile } from "../util/window-state";
  import { get } from "svelte/store";
  const dispatch = createEventDispatcher();

  export let target;
  export let system = 0x00;
  export let palette = getPalette({ system });

  let curPal = fromPalette(palette);
  $: curPal = fromPalette(palette);

  function fromPalette(pal) {
    const npal = [[0, pal[0]]];
    for (let i = 1; i < pal.length; i++) {
      const p = pal[i];
      if (
        !npal.find((o) => {
          if (o[0] === 0) return false;
          return o[1] === p;
        })
      ) {
        npal.push([i, p]);
      }
    }
    // npal[0] = [0, pal[0]];
    return npal;
  }

  let autoCenter = $windowIsMobile;

  let x = 0;
  let y = 0;
  const padding = 10;
  let container;
  let visibility = "hidden";
  onMount(() => {
    const contentSize = container.getBoundingClientRect();

    let foundMatch = false;
    if (target && !autoCenter) {
      const targetRect = target.getBoundingClientRect();

      const constraints = [
        // {
        //   left: targetRect.left - padding - contentSize.width,
        //   top: targetRect.top,
        // },
        {
          left: targetRect.right - contentSize.width,
          top: targetRect.top - contentSize.height - padding,
        },
        // {
        //   left: targetRect.left + targetRect.width + padding,
        //   top: targetRect.top,
        // },
        // {
        //   left: targetRect.left,
        //   top: targetRect.top + padding + targetRect.height,
        // },
        // {
        //   left: targetRect.left,
        //   top: targetRect.top - padding - contentSize.height,
        // },
      ];

      for (let c of constraints) {
        const { left, top } = c;
        if (
          left + contentSize.width + padding < window.innerWidth &&
          top + contentSize.height + padding < window.innerHeight &&
          top >= 46 &&
          left >= 0
        ) {
          x = left;
          y = top;
          foundMatch = true;
          break;
        }
      }
    }

    if (!foundMatch) {
      x = (window.innerWidth - contentSize.width) / 2;
      y = (window.innerHeight - contentSize.height) / 2;
      autoCenter = true;
    }

    visibility = "initial";
  });

  function cancelPopup(ev) {
    const isNode = ev.target && ev.target.nodeType === Node.ELEMENT_NODE;
    if (isNode && (ev.target === target || target.contains(ev.target))) {
      // dispatch("select", null);
      return;
      // if (
      //   ev.type === "touchstart" ||
      //   ev.type === "mousedown" ||
      //   ev.type === "click"
      // ) {
      //   ev.preventDefault();
      //   ev.stopImmediatePropagation();
      //   return;
      // }
    }

    if (isNode && (ev.target === container || container.contains(ev.target))) {
      // allow
    } else {
      dispatch("cancel");
    }
  }
</script>

<div
  class="container"
  bind:this={container}
  class:autoCenter
  class:system1={system == 1}
  style="--padding: {padding}px; --default-background: {system == 1
    ? 'hsl(0,0%,40%)'
    : 'hsl(0,0%,90%)'}; visibility: {visibility}; left: {x}px; top: {y}px;"
>
  <div style={`color: ${system == 1 ? "white" : "black"}`}>
    Select a color...
  </div>
  <div class="grid">
    {#each curPal as [index, color]}
      <div
        class:transparent={index == 0}
        class="cell"
        style="--color: {color}"
        role="none"
        on:click={(ev) => {
          ev.preventDefault();
          dispatch("select", { color, index });
        }}
      ></div>
    {/each}
  </div>
</div>

<svelte:window
  on:scroll|passive={cancelPopup}
  on:mousewheel={cancelPopup}
  on:wheel={cancelPopup}
  on:resize={cancelPopup}
  on:mousedown={cancelPopup}
  on:touchstart={cancelPopup}
  on:click={cancelPopup}
/>

<style>
  .container {
    position: fixed;
    top: 0;
    left: 0;
    /* --padding: 5px; */
    --padding: 0px;
    padding: 20px;
    background: white;
    border: 1px solid black;
    box-shadow:
      2px 0px 0px black,
      0px 2px 0px black,
      2px 2px 0px black;
    z-index: var(--z-index-popup);

    --columns: 4;
    --cell-size: 30px;
    box-sizing: border-box;
    background-color: var(--default-background);
    gap: 10px;
    display: flex;
    flex-direction: column;
  }
  .grid {
    grid-template-columns: repeat(
      var(--columns),
      minmax(var(--cell-size), 1fr)
    );
    display: grid;
    grid-gap: var(--padding);
  }

  .autoCenter {
    --cell-size: 48px;
  }

  .cell {
    aspect-ratio: 1;
    cursor: pointer;
    width: var(--cell-size);
    height: var(--cell-size);
    box-sizing: border-box;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--color);
  }
  .cell.transparent {
    background-color: transparent;
    border: 1px dashed black;
  }
  .system1 .cell.transparent {
    border-color: white;
  }
</style>
